import React from 'react'
import { UIButton, type UIButtonProps } from './ui-button'
import { cn } from '../../lib/utils'
import { UIBox } from '../layout/ui-box'

export interface UIButtonWithBadgeProps extends UIButtonProps {
  badge?: string | number
  badgeColor?: 'default' | 'destructive' | 'secondary'
  showBadge?: boolean
}

/**
 * Button with Badge Component
 * Based on common notification badge patterns
 * Use for cart items, notifications, counters
 */
export const UIButtonWithBadge = React.forwardRef<HTMLButtonElement, UIButtonWithBadgeProps>(
  ({ badge, badgeColor = 'destructive', showBadge = true, children, className, ...props }, ref) => {
    const shouldShowBadge = showBadge && badge !== undefined && badge !== null && badge !== '' && badge !== 0

    const badgeVariants = {
      default: 'bg-primary text-primary-foreground',
      destructive: 'bg-destructive text-white',
      secondary: 'bg-secondary text-secondary-foreground'
    }

    return (
      <UIBox className="relative inline-flex">
        <UIButton
          className={className}
          ref={ref}
          {...props}
        >
          {children}
        </UIButton>
        {shouldShowBadge && (
          <span
            className={cn(
              "absolute -top-2 -right-2 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none rounded-full min-w-[1.25rem] h-5",
              badgeVariants[badgeColor]
            )}
          >
            {typeof badge === 'number' && badge > 99 ? '99+' : badge}
          </span>
        )}
      </UIBox>
    )
  }
)

UIButtonWithBadge.displayName = "UIButtonWithBadge"